import { render, staticRenderFns } from "./CalendarEventDetailsDialog.vue?vue&type=template&id=553678f8&scoped=true"
import script from "./CalendarEventDetailsDialog.vue?vue&type=script&lang=js"
export * from "./CalendarEventDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./CalendarEventDetailsDialog.vue?vue&type=style&index=0&id=553678f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553678f8",
  null
  
)

export default component.exports